module.exports = __webpack_public_path__ + "img/rejected.9f6a19c6.svg";